import React from "react";
import AppModal from "../common/AppModal";
import CreateStudentFeeLedgerForm from "../../forms/CreateStudentFeeLedgerForm";

interface RecordTransactionModalProps {
  open: boolean;
  onClose: () => void;
  studentId: string;
  termId: string;
  loading: boolean;
  error: string | null;
}

const RecordTransactionModal: React.FC<RecordTransactionModalProps> = ({
  open,
  onClose,
  studentId,
  termId,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Record Ledger Entry"
    width="md"
    loading={loading}
  >
    <CreateStudentFeeLedgerForm
      studentId={studentId}
      termId={termId}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default RecordTransactionModal;
